// ColumnPicker — popover with checkbox list for column visibility.

import { useState } from "react";
import { Icon } from "@/lib/icons";

export interface ColumnPickerColumn {
  key: string;
  label: string;
}

export interface ColumnPickerProps {
  columns: ColumnPickerColumn[];
  visible: string[];
  onChange: (visible: string[]) => void;
}

export function ColumnPicker({ columns, visible, onChange }: ColumnPickerProps) {
  const [open, setOpen] = useState(false);
  const visibleSet = new Set(visible.length ? visible : columns.map(c => c.key));
  return (
    <div className="lex-popover-wrap">
      <button
        type="button"
        className="lex-toolbar-btn"
        onClick={() => setOpen(o => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <Icon.Filter size={14} aria-hidden="true" />
        <span>Columns</span>
      </button>
      {open ? (
        <>
          <div className="lex-popover-scrim" onClick={() => setOpen(false)} aria-hidden="true" />
          <div className="lex-popover" role="menu">
            <div className="lex-popover__heading">Columns</div>
            {columns.map(c => (
              <label key={c.key} className="lex-popover__row" style={{ cursor: "pointer" }}>
                <input
                  type="checkbox"
                  checked={visibleSet.has(c.key)}
                  onChange={(e) => {
                    const next = new Set(visibleSet);
                    if (e.target.checked) next.add(c.key); else next.delete(c.key);
                    onChange(Array.from(next));
                  }}
                />
                <span>{c.label}</span>
              </label>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
}

export default ColumnPicker;
